import React, { useState } from 'react';
import { TermsAndConditionsModal } from './TermsAndConditionsModal';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
import './TermsOfUseDisclaimer.css';

export const TermsOfUseDisclaimer: React.FC = () => {
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

  const openTermsModal = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsTermsModalOpen(true);
  };

  const closeTermsModal = () => {
    setIsTermsModalOpen(false);
  };

  const openPrivacyModal = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsPrivacyModalOpen(true);
  };

  const closePrivacyModal = () => {
    setIsPrivacyModalOpen(false);
  };

  return (
    <>
      <p className="terms-disclaimer">
        By using Gymea Edu, you agree to our{' '}
        <button 
          className="terms-disclaimer-link" 
          onClick={openTermsModal}
          type="button"
        >
          Terms of Use
        </button>
        {' '}and{' '}
        <button
          className="terms-disclaimer-link"
          onClick={openPrivacyModal}
          type="button"
        >
          Privacy Policy
        </button>
        .
      </p>
      <TermsAndConditionsModal isOpen={isTermsModalOpen} onClose={closeTermsModal} />
      <PrivacyPolicyModal isOpen={isPrivacyModalOpen} onClose={closePrivacyModal} />
    </>
  );
};
